import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=ce0efa3c&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/advice.css?vue&type=style&index=0&id=ce0efa3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0efa3c",
  null
  
)

export default component.exports